export const StPersonalInformation = [
    {
      label: "Student Name",
      name: "studentName",
      type: "text",
    },
    {
      label: "Gender",
      name: "gender",
      type: "select",
      options: ["Male", "Female", "Other"],
    },
    {
      label: "Father's Name",
      name: "fatherName",
      type: "text",
    },
    {
      label: "Mother Name",
      name: "motherName",
      type: "text",
    },
    {
      label: "Primary Phone",
      name: "primaryPhone",
      type: "text",
    },
    {
      label: "Email ID",
      name: "email",
      type: "email",
    },
    {
      label: "Aadhar Number",
      name: "aadharNumber",
      type: "text",
    },
    {
      label: "Date of Birth",
      name: "dateOfBirth",
      type: "date",
    },
    // {
    //   label: "Secondary Phone",
    //   name: "secondaryPhone",
    //   type: "text",
    // },
  ];

 export  const studentCradesial = [
    {
      label: "username",
      name: "username",
      type: "text",
      readOnly: true,
    },
    {
      label: "Password",
      name: "password",
      type: "password",
    },
  ];


  export const ListOfRequirements = [
    {
      label: "Center Logo",
      name: "logo",
      type: "file",
      accept:"image/*"
    },
   
    {
      label: "Center Director Signature",
      name: "signature",
      type: "file",
      accept:"image/*"
    },
    // {
    //   label: "Center Director Adhar Card",
    //   name: "aadharcard",
    //   type: "file",
    // },
  ];


  